module.exports = __webpack_public_path__ + "static/media/imaginxp-loginbanner-1.0f243c38.jpg";